import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { api, useAuth } from '../lib/auth';
import { toast } from 'sonner';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = React.useRef(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setError('No session_id found in URL');
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id });
        setUser(data.user);
        if (data.user?.email) localStorage.setItem('am_billing_email', data.user.email);
        toast.success(`Welcome${data.user?.name ? ', ' + data.user.name : ''}!`);
        // Clear the hash and go to marketplace
        window.history.replaceState(null, '', '/marketplace');
        navigate('/marketplace', { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || 'Sign-in failed');
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="page-auth-callback">
      <div className="text-center">
        {error ? (
          <>
            <div className="font-mono text-xs uppercase tracking-widest text-[#ff2a2a]">Sign-in failed</div>
            <div className="mt-3 font-display text-3xl uppercase tracking-tight">{error}</div>
            <button
              onClick={() => navigate('/signin', { replace: true })}
              className="mt-6 bg-[#ff2a2a] hover:bg-[#e01f1f] text-white text-sm font-semibold px-6 py-3 transition-colors"
              data-testid="auth-cb-retry"
            >
              Try again
            </button>
          </>
        ) : (
          <>
            <Loader2 className="w-10 h-10 text-[#ff2a2a] mx-auto animate-spin" />
            <div className="mt-4 font-display text-2xl uppercase tracking-tight">Signing you in…</div>
            <div className="mt-2 text-sm text-zinc-500">One second while we warm up the engine.</div>
          </>
        )}
      </div>
    </div>
  );
}
